import React from 'react';
import { Button, Icon, Input } from 'antd';
import Highlighter from 'react-highlight-words';

import { removeEmptyValueObject } from 'src/constants/format';

export function numberWithSpaces(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function phoneNumberWithSpaces(x) {
	return (
		x &&
		x
			.toString()
			.replace(/\D/g, '')
			.replace(/^(.{3})(.{2})(.{3})(.*)$/, '$1 $2 $3 $4')
	);
}

const handleSearch = (selectedKeys, confirm, dataIndex, self, searchFunction) => {
	confirm();
	self.setState(
		{
			params: {
				...self.state.params,
				[dataIndex]: selectedKeys[0]
			},
			searchText: selectedKeys[0],
			searchedColumn: dataIndex
		},
		() => {
			removeEmptyValueObject(self.state.params);
			searchFunction();
		}
	);
};

const handleReset = (clearFilters, dataIndex, self, searchFunction) => {
	clearFilters();
	self.setState(
		{
			current: 1,
			searchText: '',
			params: {
				...self.state.params,
				[dataIndex]: undefined
			}
		},
		() => {
			removeEmptyValueObject(self.state.params);
			searchFunction();
		}
	);
};

const getColumnSearchProps = (dataIndex, name, self, searchFunction) => ({
	filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
		return (
			<div style={{ padding: 8 }}>
				<Input
					ref={node => {
						self.searchInput = node;
					}}
					placeholder={`Rechercher ${name}`}
					value={selectedKeys[0]}
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, self, searchFunction)}
					style={{ width: 307, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => handleSearch(selectedKeys, confirm, dataIndex, self, searchFunction)}
					icon="search"
					size="small"
					style={{ width: 150, marginRight: 8 }}
				>
					Rechercher
				</Button>
				<Button
					onClick={() => handleReset(clearFilters, dataIndex, self, searchFunction)}
					size="small"
					style={{ width: 150 }}
				>
					Réinitialiser
				</Button>
			</div>
		);
	},
	filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
	// onFilter: (value, record) =>
	//     record[dataIndex]
	//         .toString()
	//         .toLowerCase()
	//         .includes(value.toLowerCase()),
	onFilterDropdownVisibleChange: visible => {
		if (visible) {
			setTimeout(() => self.searchInput.select());
		}
	},
	render: text => {
		// console.log(text);
		// console.log(dataIndex);
		// console.log(self.state.params[dataIndex]);
		const params = self.state.params[dataIndex] && self.state.params[dataIndex].toString();
		// console.log(params);

		return self.state.searchedColumn === dataIndex ? (
			<Highlighter
				highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
				searchWords={[dataIndex ? params : key ? params : '']}
				autoEscape
				textToHighlight={text.toString()}
			/>
		) : (
			text
		);
	}
});

export default getColumnSearchProps;
